import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var CollectionFilters = function (_a) {
    var children = _a.children;
    return _jsx(_Fragment, { children: children });
};
export { CollectionFilters };
